export default "__VITE_ASSET__72a09441__"